import { useContext } from "react";
import TurnosConvencionesContext from "../../../../store/modal-convenciones-context";

import "./sedes-convenciones.css";

const SedesConvenciones = () => {
    const { convenciones } = useContext(TurnosConvencionesContext);

    let convencionesAgrupadas = convenciones.reduce((prev, convencion) => {
        if (
            Object.prototype.hasOwnProperty.call(
                prev,
                convencion.sede_abreviatura
            )
        )
            return prev;

        prev[convencion.sede_abreviatura] = convencion;
        return prev;
    }, {});

    convencionesAgrupadas = Object.values(convencionesAgrupadas);

    return (
        <>
            <div className="sedes-convenciones-container">
                <h6>Abreviaturas de sedes</h6>
                <p>
                    {convencionesAgrupadas.map((convencion) => {
                        return (
                            <span key={convencion.sede_sigla}>
                                /{" "}
                                <strong>{convencion.sede_abreviatura}: </strong>
                                {convencion.sede_sigla} <br />
                            </span>
                        );
                    })}
                </p>
                {/* <h6>Horas extras</h6>
                <p>
                    Máximo horas trabajadas al mes: <strong>192</strong>
                    <br />
                    Máximo horas trabajadas a la semana: <strong>47</strong>
                </p> */}
            </div>
        </>
    );
};

export default SedesConvenciones;
